import React from 'react';
import PartNumber from 'shared/components/parameters/PartNumber';
import Revision from 'shared/components/parameters/Revision';
import StencilFile from 'shared/components/parameters/StencilFile';
import LengthText from 'shared/components/pallets/LengthText';
import WidthText from 'shared/components/pallets/WidthText';
import PrintConfirmation from 'shared/components/PrintConfirmationRadio';
import SpecialInstruction from 'shared/components/SpecialInstruction';
import ProductQuoteNumber from 'shared/components/ProductQuoteNumber';
import RowSelected from 'shared/components/RowSelected';
import ColumnSelected from 'shared/components/ColumnSelected';
import MaterialThickness from 'shared/components/carriers/MaterialThickness';
import RequiredInformation from 'shared/components/RequiredInformation';
import Hardware from 'wave_solder_pallets/components/Hardware';
import {
  partNumber as partNumberTooltip,
  revision as revisionTooltip,
  materialThickness as materialThicknessTooltip,
  stencilFile as stencilFileTooltip,
  carrierWidth as carrierWidthTooltip,
  carrierLength as carrierLengthTooltip,
  printConfirmation as printConfirmationTooltip,
} from 'wave_solder_pallets/data/tooltips';

const Parameters = (props) => {
  const { parameters, validator } = props;

  validator.purgeFields();

  return (
    <div>
      <div className="row">
        <div className="col-12 col-md-6">
          <PartNumber {...props} tooltip={partNumberTooltip}>
            <span className="error">
              {validator.message(`Part Number`, parameters.part_number, 'required|min:3')}
            </span>
          </PartNumber>
        </div>
        <div className="col-12 col-md-6">
          <Revision
            {...props}
            label="Revision number"
            tooltip={revisionTooltip}>
            <span className="error">
              {validator.message(`Revision`, parameters.revision, 'required')}
            </span>
          </Revision>
        </div>
        <div className="col-12 col-md-6">
          <MaterialThickness {...props} tooltip={materialThicknessTooltip} />
        </div>
        <div className="col-12 col-md-6">
          <StencilFile
            required
            {...props}
            tooltip={stencilFileTooltip}>
            <span className="error">
              {validator.message(`Zip File`, parameters.filename, 'required')}
            </span>
          </StencilFile>
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-md-6">
              <WidthText {...props} tooltip={carrierWidthTooltip}>
                <span className="error">
                  {validator.message(`Pallet Width`, parameters.pallet_width, 'required|numeric|min:0.1,num|max:24,num')}
                </span>
              </WidthText>
            </div>
            <div className="col-md-6">
              <LengthText {...props} tooltip={carrierLengthTooltip}>
                <span className="error">
                  {validator.message(`Pallet Length`, parameters.pallet_length, 'required|numeric|min:0.1,num|max:20,num')}
                </span>
              </LengthText>
            </div>
          </div>
        </div>
        <div className="col-12">
          <PrintConfirmation
            {...props}
            required
            tooltip={printConfirmationTooltip}>
            <span className="error">
              {validator.message(`Check plot confirmation`, parameters.print_confirmation, 'required')}
            </span>
          </PrintConfirmation>
        </div>
        <div className="col-12">
          <Hardware {...props} validator={validator} required />
        </div>

        <div className="col-12">
          <SpecialInstruction {...props} />
          <ProductQuoteNumber {...props} />
          <RowSelected {...props} />
          <ColumnSelected {...props} />
          <RequiredInformation />
        </div>
      </div>
    </div>
  );
};

export default Parameters;
